import { h, Component } from 'preact'
import style from './styles/button.scss'

class Button extends Component {
  handleClick = (event) => {
    event.preventDefault()
    const {value, onClick} = this.props
    onClick(value)
  }

  render ({children, disabled, class: mixin}) {
    return (
      <button class={(disabled ? style.disabled : style.normal) + (mixin ? ` ${mixin}` : '')} onClick={this.handleClick}>
        {children}
      </button>
    )
  }
}

export default Button



// WEBPACK FOOTER //
// ./components/forms/Button.js